/**
 * Adding another business reuses the one setup flow there is: choose a trade
 * on the landing page, fill in the profile on /setup. Two flags let /setup
 * open for someone who already has a business — a cold load of /setup
 * without either still goes straight into the app, as before:
 *
 *   add — "Add business" in the switcher. The landing page says so, and every
 *         trade chosen there sets up a new business, even one already here.
 *   new — a trade chosen on the ordinary homepage that has no business on this
 *         device yet. (A trade that does is opened instead — see
 *         `resolveHomepageChoice`.)
 */
export const ADD_BUSINESS_PARAM = 'add';
export const NEW_BUSINESS_PARAM = 'new';
export const ADD_BUSINESS_PATH = `/?${ADD_BUSINESS_PARAM}=1`;

export const isAddingBusiness = (params: URLSearchParams): boolean => params.get(ADD_BUSINESS_PARAM) === '1';

/** Whether /setup was opened, on purpose, to create another business beside the existing ones. */
export const opensSetupForAnotherBusiness = (params: URLSearchParams): boolean =>
  isAddingBusiness(params) || params.get(NEW_BUSINESS_PARAM) === '1';

/**
 * Where setup for a trade lives. `first`: nothing on this device yet, so no
 * flag is needed. `new` and `add`: see above.
 */
export function setupPath(templateId: string, mode: 'first' | 'new' | 'add'): string {
  const base = `/setup?template=${encodeURIComponent(templateId)}`;
  if (mode === 'first') return base;
  return `${base}&${mode === 'add' ? ADD_BUSINESS_PARAM : NEW_BUSINESS_PARAM}=1`;
}
